var map = {
	"./boleta.png": 6708,
	"./borrar.png": 9982,
	"./buscar.png": 3282,
	"./caja.png": 2298,
	"./cerrar.png": 2204,
	"./chancho.png": 6666,
	"./colegiados.png": 7395,
	"./comunicado.png": 1859,
	"./coupon.png": 6132,
	"./credit-card.png": 1115,
	"./cupon.png": 9385,
	"./docucargando.gif": 2408,
	"./download.png": 7361,
	"./editar.png": 2500,
	"./eventos.png": 7198,
	"./eye.png": 6253,
	"./flecha.png": 318,
	"./fondo.png": 355,
	"./hola.png": 2704,
	"./ilimitado.png": 376,
	"./imagen.png": 1671,
	"./imgMesas/10A.png": 8177,
	"./imgMesas/10N.png": 458,
	"./imgMesas/10R.png": 3045,
	"./imgMesas/10V.png": 9345,
	"./imgMesas/2A.png": 1042,
	"./imgMesas/2N.png": 2709,
	"./imgMesas/2R.png": 5589,
	"./imgMesas/2V.png": 2368,
	"./imgMesas/3A.png": 1487,
	"./imgMesas/3N.png": 2380,
	"./imgMesas/3R.png": 5136,
	"./imgMesas/3V.png": 4313,
	"./imgMesas/4A.png": 2593,
	"./imgMesas/4N.png": 1046,
	"./imgMesas/4R.png": 3618,
	"./imgMesas/4V.png": 5309,
	"./imgMesas/5A.png": 7751,
	"./imgMesas/5N.png": 8336,
	"./imgMesas/5R.png": 4173,
	"./imgMesas/5V.png": 974,
	"./imgMesas/6A.png": 7780,
	"./imgMesas/6N.png": 8830,
	"./imgMesas/6R.png": 1716,
	"./imgMesas/6V.png": 9791,
	"./imgMesas/7A.png": 9996,
	"./imgMesas/7N.png": 942,
	"./imgMesas/7R.png": 246,
	"./imgMesas/7V.png": 5684,
	"./imgMesas/8A.png": 2852,
	"./imgMesas/8N.png": 5734,
	"./imgMesas/8R.png": 3472,
	"./imgMesas/8V.png": 848,
	"./imgMesas/9A.png": 2523,
	"./imgMesas/9N.png": 4638,
	"./imgMesas/9R.png": 9175,
	"./imgMesas/9V.png": 1103,
	"./logo_cip.png": 4528,
	"./mapa.jpeg": 8225,
	"./mas.png": 3425,
	"./menos.png": 1024,
	"./misentradas.png": 1807,
	"./misreservas.png": 2727,
	"./pagos.png": 9430,
	"./pajarito.gif": 5384,
	"./parrillamenu.png": 3885,
	"./patito.gif": 3365,
	"./plus.png": 5321,
	"./pollo.png": 5648,
	"./qr.png": 341,
	"./res.png": 415,
	"./salir.png": 4121,
	"./trabajador.png": 1186,
	"./trabajadora.png": 9520,
	"./usuarios.png": 2317,
	"./vege.png": 9512,
	"./zonaparrillas.png": 1639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;